export const getCurrentYear = (): number => {
  const date = new Date();
  return date.getFullYear();
};
